/**
 * @param id: 题目唯一标识
 * @param title: 题目
 * @param desc: 题目描述
 * @param type: btnAdd\datePicker\drag\drawer\doubleInputText\inputNumber\inputText\mulitpleModal\radio\textarea\radioInput
 * @param next：下一道题的id
 * @param {Array} answers：在type为radio \ mulitpleModal \ drag 的答案
 * @param {string} answers.id : 答案唯一标识
 * @param {string} answers.answertitle: 答案标题
 * @param {string} answers.next: 下一道题的id
 * @param {string} answers.desc: 描述
 */
const legalQuestionsList = [
  // 1
  {
    id: '1',
    title:
      'Je pense avoir besoin de retirer les fonds de mes investissements dans :',
    type: 'radio',
    answers: [
      {
        id: '1-1',
        answertitle: '1-3 ans',
        points: 1,
      },
      {
        id: '1-2',
        answertitle: '3-10 ans',
        points: 3,
      },
      {
        id: '1-3',
        answertitle: '10 ans',
        points: 10,
      },
    ],
    next: '2',
  },
  // 2
  {
    id: '2',
    title:
      "Une fois que je commence à retirer des fonds de mon investissement, je pense dépenser l'argent dans :",
    type: 'radio',
    next: '3',
    answers: [
      {
        id: '2-1',
        answertitle: 'Moins de 2 ans',
        points: 0,
      },
      {
        id: '2-2',
        answertitle: '2-5 ans',
        points: 1,
      },
      {
        id: '2-3',
        answertitle: '6-10 ans',
        points: 4,
      },
      {
        id: '2-4',
        answertitle: '11+ ans',
        points: 8,
      },
    ],
  },
  // 3
  {
    id: '3',
    title: 'Mes connaissances en matière d’investissements sont : ',
    type: 'radio',
    next: '4',
    answers: [
      {
        id: '3-1',
        answertitle: 'Très limitées',
        points: 1,
      },
      {
        id: '3-2',
        answertitle: 'Limitées',
        points: 3,
      },
      {
        id: '3-3',
        answertitle: 'Bonnes',
        points: 7,
      },
      {
        id: '3-4',
        answertitle: 'Excellentes',
        points: 10,
      },
    ],
  },
  // 4
  {
    id: '4',
    title: "Quand j'investis mon argent :",
    type: 'radio',
    next: '5',
    answers: [
      {
        id: '4-1',
        answertitle: "J'ai peur qu'il perde de la valeur",
        points: 0,
      },
      {
        id: '4-2',
        answertitle:
          'Je suis autant préoccupé·e par les pertes que par les gains',
        points: 4,
      },
      {
        id: '4-3',
        answertitle: `Je m'intéresse davantage aux gains potentiels qu’aux pertes`,
        points: 8,
      },
    ],
  },
  // 5
  {
    id: '5',
    type: 'select',
    title: 'Sélectionnez les investissements que vous possédez actuellement :',
    desc: 'Vous pouvez en choisir 3, un par ligne',
    next: '6',
    answers: [
      {
        id: '5-1',
        options: [
          {
            id: '5-1-1',
            label: 'Obligations et/ou fonds obligataire',
            points: 3,
          },
          {
            id: '5-1-2',
            label: "Actions et/ou fonds d'actions",
            points: 6,
          },
          {
            id: '5-1-3',
            label:
              'Cryptos et/ou Titres internationaux et/ou fonds de titres internationaux',
            points: 8,
          },
          {
            id: '5-1-4',
            label: 'aucun',
            points: 0,
          },
        ],
      },
      {
        id: '5-2',
        options: [
          {
            id: '5-2-1',
            label: 'Obligations et/ou fonds obligataire',
            points: 3,
          },
          {
            id: '5-2-2',
            label: "Actions et/ou fonds d'actions",
            points: 6,
          },
          {
            id: '5-2-3',
            label:
              'Cryptos et/ou Titres internationaux et/ou fonds de titres internationaux',
            points: 8,
          },
          {
            id: '5-2-4',
            label: 'aucun',
            points: 0,
          },
        ],
      },
      {
        id: '5-3',
        options: [
          {
            id: '5-3-1',
            label: 'Obligations et/ou fonds obligataire',
            points: 3,
          },
          {
            id: '5-3-2',
            label: "Actions et/ou fonds d'actions",
            points: 6,
          },
          {
            id: '5-3-3',
            label:
              'Cryptos et/ou Titres internationaux et/ou fonds de titres internationaux',
            points: 8,
          },
          {
            id: '5-3-4',
            label: 'aucun',
            points: 0,
          },
        ],
      },
    ],
  },
  {
    id: '6',
    title: `Considérez le scénario suivant : imaginez que, ces trois derniers mois, les marchés boursiers ont perdu 25 % de leur valeur. 
    Une de vos actions a également perdu 25 % de sa valeur. 
    Que feriez-vous dans cette situation ?`,
    type: 'radio',
    next: '7',
    answers: [
      {
        id: '6-1',
        answertitle: 'Je vends toutes mes actions',
        points: 0,
      },
      {
        id: '6-2',
        answertitle: 'Je vends une partie de mes actions',
        points: 2,
      },
      {
        id: '6-3',
        answertitle: 'Je ne fais rien',
        points: 5,
      },
      {
        id: '6-4',
        answertitle: "J'achète plus d'actions",
        points: 8,
      },
    ],
  },
  {
    id: '7',
    title: `Examinez le tableau ci-dessous : imaginez que vous avez le choix entre cinq plans d'investissement : A, B, C, D ou E. 
    Lequel choisiriez-vous ?`,
    type: 'radioSelect',
    isEnd: true,
    answers: [
      {
        id: '7-1',
        answertitle: 'Je vends toutes mes actions',
        points: 0,
        yareRate: '7.20%',
        bastCase: '16.30%',
        worstCase: '-5.60%',
        option: 'A',
      },
      {
        id: '7-2',
        answertitle: 'Je vends une partie de mes actions',
        points: 3,
        yareRate: '9.00%',
        bastCase: '25.00%',
        worstCase: '-12.10%',
        option: 'B',
      },
      {
        id: '7-3',
        answertitle: 'Je ne fais rien',
        points: 6,
        yareRate: '10.40%',
        bastCase: '33.60%',
        worstCase: '-10.20%',
        option: 'C',
      },
      {
        id: '7-4',
        answertitle: "J'achète plus d'actions",
        points: 8,
        yareRate: '11.70%',
        bastCase: '42.80%',
        worstCase: '-24.00%',
        option: 'D',
      },
      {
        id: '7-5',
        answertitle: "J'achète plus d'actions",
        points: 10,
        yareRate: '12.50%',
        bastCase: '50.00%',
        worstCase: '-28.2%',
        option: 'E',
      },
    ],
  },
];
/**
 * @description:
 * @param type:btnAdd\datePicker\drag\drawer\doubleInputText\inputNumber\inputText\mulitpleModal\radio\textarea
 * @param value：1：字符串，2：数组，3：数组对象, 4: 数字, 5: 对象
 */
const legalFormValueType = new Map([
  ['radio', '5'],
  ['select', '3'],
  ['radioSelect', '5'],
]);
export { legalQuestionsList, legalFormValueType };
